import { Toaster as Sonner } from "sonner";

/**
 * Desk toast host — plan/27 action feedback (calm success / plain error).
 * Mount once at app root. Prefer field helpers for invalid inputs; toast for
 * done / fail / queued. Avoid toast spam on POS Floor.
 */
export function Toaster() {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      closeButton
      gap={10}
      offset={20}
      duration={3600}
      toastOptions={{
        classNames: {
          toast:
            "rounded-[var(--radius-xl)] border border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-foreground)] shadow-[var(--shadow-float)] font-[family-name:var(--font-sans)] text-sm",
          title: "font-medium tracking-tight",
          description: "text-[var(--color-muted)] text-xs",
          success:
            "border-[var(--color-ok)]/25 bg-[color-mix(in_oklab,var(--color-ok)_6%,var(--color-card))]",
          error:
            "border-[var(--color-destructive)]/30 bg-[color-mix(in_oklab,var(--color-destructive)_7%,var(--color-card))]",
          closeButton:
            "border-[var(--color-border)] bg-[var(--color-card)] text-[var(--color-muted)]",
        },
      }}
    />
  );
}
